import type { FC } from "react";

import { useSelector } from "react-redux";

import { Button, Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { selectIsContactsDisabledByCountry } from "app/pages/sales-intelligence/sub-modules/contacts-tab/store/selectors";
import type { IPlainObject } from "app/pages/sales-intelligence/types/plainObject";

import { StyledTopCompaniesContactDetailsOverlay } from "../containers/styles";

function withDisabledByCountryOverlay<C extends IPlainObject = IPlainObject>(Component: FC<C>): FC<C> {
    return function WrappedWithApproveTermsGuard({ ...props }: C) {
        const isContactsDisabled = useSelector(selectIsContactsDisabledByCountry);

        if (isContactsDisabled) {
            return (
                <StyledTopCompaniesContactDetailsOverlay>
                    <Tooltip content={translate("si.top-companies.disabled-by-countries.tooltip-text")}>
                        <div>
                            <Button
                                type="flat"
                                isDisabled
                            >
                                {translate("si.advanced_search.results_section.contacts.button.reveal")}
                            </Button>
                        </div>
                    </Tooltip>
                </StyledTopCompaniesContactDetailsOverlay>
            );
        }

        return <Component {...props} />;
    };
}

export default withDisabledByCountryOverlay;
